import SharingComponent from "./sharingComponent";

import { createSharingUrls } from "./../utilities/utils";

import { OPENED_SHARE_MENU_NEXTGEN } from "./../analytics/analyticsevents";

export default class NextgenSharing {
  appState;
  articleDetails;
  options;
  DOMContainer;

  constructor(appState, articleDetails, DOMContainer, options = {}) {
    this.appState = appState;
    this.articleDetails = articleDetails;
    this.DOMContainer = DOMContainer;
    this.options = options;
    this.init();
  }

  close = () => {
    this.DOMContainer.classList.add("hidden");
    this.DOMContainer.removeEventListener("click", (evt) => {
      this.close(evt);
    });
  };

  init() {
    const url = this.createUrl();
    let links = null;
    if (url) {
      links = createSharingUrls(
        url,
        {
          title: this.articleDetails.Title ? this.articleDetails.Title : "",
          intro: this.articleDetails.Introduction
            ? this.articleDetails.Introduction
            : "",
        },
        this.options.sharingOptions,
        this.appState.isDesktop
      );
    }
    this.shareComponent = new SharingComponent(
      this.appState,
      links,
      this.DOMContainer,
      this.options,
      OPENED_SHARE_MENU_NEXTGEN
    );
    this.DOMContainer.classList.remove("hidden");
  }

  createUrl() {
    let url = null;
    if (this.options.shareFromNextgen) {
      url = this.appState._nextgenSharingUrl;
      if (url) {
        url = url.replace(/\{0\}/g, this.articleDetails.ContentPackageId);
        url = url.replace(/\{1\}/g, this.articleDetails.PublicationID);
        url = url.replace(/\{2\}/g, this.articleDetails.PageNumber);
        url = url.replace(/\{3\}/g, this.articleDetails.ContentId);
        const intro = this.articleDetails.Introduction;
        const title = this.articleDetails.Title;
        if (intro) {
          url = url.replace(/\{4\}/g, encodeURIComponent(intro));
        } else {
          url = url.replace(/\{4\}/g, encodeURIComponent(title));
        }
        url = url.replace(/\{5\}/g, encodeURIComponent(title));
        url = url.replace(
          /\{6\}/g,
          encodeURIComponent(this.articleDetails.ImageUrl)
        );
      }

      return url;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/nextGenSharing.js